var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHash = function SvgHash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20.773 14A9.032 9.032 0 1 0 14 20.774M18.75 17.252v3.001M17.252 18.752h3.001M9.697 15.452l1.15-6.903M13.15 15.452l1.15-6.903M15.8 10.3H8.797M15.2 13.7H8.197"
  })));
};
export { SvgHash as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNGVkNjYzY2E2Yzg5MDBkMmNmNGEwYzcwZDc1YjU2NmMuc3ZnIjs=";